import { NgComponentOutlet } from '@angular/common';
import { Component, inject, Injector } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  AdaptiveMatDialogRef,
  ALT_MAT_DIALOG_REF,
  IframeDialogRef,
} from '../../core/classes/mat-dialog-ref-injectables';
import { ItemsModalComponent } from '../items/items-modal/items-modal.component';
import { TItemModalComponentData } from '../items/items-modal/items-modal.interface';
import { IItemBase, IItemJoins } from '../items/items.interface';

@Component({
  imports: [NgComponentOutlet],
  selector: 'app-standalone-item',
  styleUrl: './standalone-item.component.scss',
  templateUrl: './standalone-item.component.html',
})
export class StandaloneItemComponent {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly translate = inject(TranslateService);

  public readonly item: (IItemBase & Pick<IItemJoins, 'board'>) | null = this.activatedRoute.snapshot.data['item'];

  public readonly widget = {
    component: ItemsModalComponent,
    injector: Injector.create({
      providers: [
        {
          provide: MAT_DIALOG_DATA,
          useValue: {
            ...(this.item ? { idForEdit: this.item.id } : {}),
            ...(this.item
              ? {}
              : {
                  title: this.translate.instant('button.addContext', {
                    context: this.translate.instant('field.item'),
                  }),
                }),
          } satisfies TItemModalComponentData,
        },
        {
          provide: ALT_MAT_DIALOG_REF,
          useClass: IframeDialogRef,
        },
        AdaptiveMatDialogRef,
      ],
    }),
  };
}
